import styled from 'styled-components';
import Color from '@/utils/color';

export const OrderPre = styled.pre`
  padding-top: 15px;
`;

export const OrderBillTable = styled.table`
  max-width: 600px;
`;

export const BillDetailLabel = styled.div`
  color: ${Color.DarkGrey};
  margin-top: 5px;
  margin-left: 5px;
  font-size: 90%;
`;

export const BillItemPrice = styled.td`
  text-align: end;
  width: 150px;
`;
